"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STORIES_API_HOMEPAGE = void 0;
var STORIES_API_HOMEPAGE = "http://stage.stories.k2.services";
exports.STORIES_API_HOMEPAGE = STORIES_API_HOMEPAGE;